import { useState } from "react";
import DownloadIcon from "@/assets/common/ic_download.svg?react";
import Popover from "@/component/Popover";
import summarySrcStore from "@/store/summarySrc.store";
import ExportPopover from "@/sections/WebSummary/Export";
import fridayReporter from "@/utils/friday";
import { getFormatDuration } from "@/utils/formatter";
import TitleGeneratingIcon from "@/assets/summary/ic_title_generating.svg?react";
import useExport from "@/sections/Summary/useExport";
import summaryCommonStore from "@/store/summaryCommon.store";

export interface IShareHeaderProps { }

const ShareHeader: React.FC<IShareHeaderProps> = () => {
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const generatedTitle = summarySrcStore((state) => state.generatedTitle);
  const titleGenerating = summarySrcStore((state) => state.titleGenerating);
  const audioInfo = summaryCommonStore((state) => state.audioInfo);
  const [showExport, setShowExport] = useState(false);
  const formatDuration = getFormatDuration(audioInfo?.audioDuration);

  const { showExportBtn } = useExport();
  
  return (
    <div className={`h-16 px-6 py-2.25 flex items-center justify-between mt-2`}>
      <div className="overflow-hidden mr-4">
        <div className={`text-4 h-6 mx-text-ellipsis`}>
          {titleGenerating && !generatedTitle ? (
            <div className="h-6 flex items-center">
              <TitleGeneratingIcon className="size-4 mr-1" />
              <span className="color-#CED2D9 text-4">标题生成中...</span>
            </div>
          ) : (
            generatedTitle
          )}
        </div>
        <div className="text-3 text-#999 h-6 lh-6">{formatDuration}</div>
      </div>
      <div className="flex items-center">
        <div id="summary-search" className="flex items-center"></div>
        {showExportBtn && <Popover
          visible={showExport}
          setVisible={(v) => {
            setShowExport(v);
            if (v) {
              fridayReporter.pushData({
                eventCode: "SummaryPage_Export",
              });
            }
          }}
          content={<ExportPopover detailInfo={detailInfo} generatedTitle={generatedTitle} />}
          placement="bottomRight"
        >
          <div className="m-l-4 size-8 flex items-center justify-center text-3.5 text-mx-secondary rounded-2.5 cursor-pointer">
            <DownloadIcon className="size-4" />
          </div>
        </Popover>}
      </div>
    </div>
  );
};

export default ShareHeader;
